import { api } from './api'

class AuthService {
  private sessionId: string | null = null

  constructor() {
    // Check for existing session in localStorage
    this.sessionId = localStorage.getItem('admin_session')
    if (this.sessionId) {
      // Add auth header to all API requests
      this.setAuthHeader(this.sessionId)
    }
  }

  private setAuthHeader(sessionId: string) {
    api.defaults.headers.common['Authorization'] = `Bearer ${sessionId}`
  }

  private removeAuthHeader() {
    delete api.defaults.headers.common['Authorization']
  }

  async login(email: string, password: string): Promise<void> {
    const response = await api.post('/auth/login', { email, password })
    const { sessionId } = response.data
    
    this.sessionId = sessionId
    localStorage.setItem('admin_session', sessionId)
    this.setAuthHeader(sessionId)
  }

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout')
    } catch (error) {
      console.warn('Logout request failed:', error)
    }
    
    this.sessionId = null
    localStorage.removeItem('admin_session')
    this.removeAuthHeader()
  }

  async checkSession(): Promise<boolean> {
    if (!this.sessionId) {
      return false
    }

    try {
      const response = await api.get('/auth/session')
      return response.data.authenticated
    } catch (error) {
      // Session invalid, clean up
      this.sessionId = null
      localStorage.removeItem('admin_session')
      this.removeAuthHeader()
      return false
    }
  }

  isAuthenticated(): boolean {
    return this.sessionId !== null
  }
}

export const authService = new AuthService()